// Generated by genversion.
export const version = '4.1.2';
//# sourceMappingURL=version.js.map